/**
 * @ngdoc Controller
 */

(function () {
    'use strict';

    angular.module('vrm.components')
        .controller('RecurringReportModalController', RecurringReportModalController);

    /**
     * @constructor
     * @ngInject
     */
    function RecurringReportModalController($scope, close, recurringReport, reportTemplates, callback, ApiService, vrmNotificationsService, vrmNotificationType, locale) {
        $scope.repeatIntervals = ['daily', 'weekly', 'monthly', 'quarterly', 'yearly'];
        $scope.everyEntries = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
        $scope.reportTypes = ['hybrid_genset', 'economic', 'dynamic-ess'];
        $scope.timezones = [];
        $scope.now = new Date();
        $scope.reportTemplates = reportTemplates;
        $scope.availableTemplates = [];
        $scope.availableTypes = $scope.reportTypes.filter(type => {
            return $scope.reportTemplates.find(template => template.report_type === type) !== undefined;
        });


        $scope.model = {
          report: $scope.availableTypes[0],
          end: 1
        };
        $scope.recurringReport = {
            repeatInterval: $scope.repeatIntervals[0],
            weekDays: $scope.everyEntries[(new Date()).getDay()],
            sendTime: new Date(),
            start: new Date(),
            end: new Date(),
            endAfter: 1,
            timezone: $scope.installation.timezone,
            reportTemplates: []
        };

        // Fetch timezones accepted by the API
        (function () {
            ApiService.call('/timezones', null, 'GET')
                .then(function (res) {
                    $scope.timezones = res.data.records;
                });
        })();

        $scope.$watch('model.report', function(reportType) {
           $scope.recurringReport.reportTemplates = [];
           $scope.availableTemplates = $scope.reportTemplates.filter(template => template.report_type === reportType);
        });

        if (recurringReport && recurringReport.id) {
            $scope.recurringReport = recurringReport;
        }

        $scope.save = function () {
            if($scope.recurringReportForm.$invalid || $scope.recurringReport.reportTemplates.length === 0) {
                locale.ready('form').then(function () {
                    vrmNotificationsService.add({
                        type: vrmNotificationType.ERROR,
                        message: locale.getString('form.fill_form_correctly')
                    });
                });
                return;
            }
            if($scope.model.end === 3) {
                delete $scope.recurringReport.endAfter;
            } else {
                delete $scope.recurringReport.end;
                if($scope.model.end === 1) {
                    $scope.recurringReport.endAfter = 0;
                }
            }
            callback(true, $scope.recurringReport);
            $.magnificPopup.close();
        };

        $scope.cancel = function () {
            callback(false);
            $.magnificPopup.close();
        };

        return {
            close: close
        };
    }
})();
